<template>
    <div v-loading="loading" @click="onClick">
        <img v-if="form.imageId" class="rounded" style="cursor: pointer;" width="100%" :src="`https://ucarecdn.com/${ form.imageId }/-/scale_crop/300x400/center/-/quality/lighter/`">
        <img v-else class="rounded" style="cursor: pointer;" width="100%" src="@/assets/images/placeholder-3-4.png">
    </div>
</template>

<script>
import uploadcare from 'uploadcare-widget'

export default {
    data() {
        return {
            loading: false,
            form: {
                imageId: this.imageId,
            }
        }
    },

    props: {
        imageId: {
            default: null,
            type: String,
        },
    },

    watch: {
        imageId() {
            this.form.imageId = this.imageId
        },
    },

    methods: {
        async onClick() {
            this.loading = true

            var dialog = uploadcare.openDialog(null, {
                publicKey: process.env.VUE_APP_UPLOADCARE,
                imagesOnly: true,
                imageShrink: '600x600',
            })

            try {
                var result = await dialog.done()
            } catch(err) {
                return false
            } finally {
                this.loading = false
            }

            this.form.imageId = result.uuid
            this.$emit('upload', result.uuid)
        },
    },
}
</script>
